module.exports = __webpack_public_path__ + "img/Group27.7a5ceb40.png";